var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIconRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.218,
    height: 25.218,
    viewBox: "0 0 25.218 25.218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12682",
    "data-name": "Group 12682",
    transform: "translate(-3.026 -3.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4666",
    "data-name": "Path 4666",
    d: "M25.773,20.207,22.207,19.8a2.794,2.794,0,0,0-2.3.8l-2.583,2.583a21.12,21.12,0,0,1-9.251-9.251l2.6-2.6a2.794,2.794,0,0,0,.8-2.3l-.407-3.538A2.809,2.809,0,0,0,8.268,3.01H5.839A2.786,2.786,0,0,0,3.031,5.916,23.853,23.853,0,0,0,25.338,28.222a2.786,2.786,0,0,0,2.906-2.808V22.986A2.782,2.782,0,0,0,25.773,20.207Z",
    transform: "translate(0 0)",
    fill: "#d71920"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconRed);
export default __webpack_public_path__ + "static/media/PhoneIconRed.a6531e2104fa1852fd99db540ff6737e.svg";
export { ForwardRef as ReactComponent };